module.exports = "<input #colorPicker\n    class=\"color-picker\"\n    type=\"color\"\n    (change)=onChange($event)\n>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/custom-color-selector/custom-color-selector.component.html
// module id = ../../../../../src/app/shared/custom-color-selector/custom-color-selector.component.html
// module chunks = 2